export default "__VITE_ASSET__38cd4ab3__"